import React, { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import useApi from "../../hooks/useApi";
import useReload from "../../hooks/useReload";
import { ReactSortable, Sortable, MultiDrag, Swap } from "react-sortablejs";
import { Button, ListGroup, ListGroupItem, Form } from "react-bootstrap";

const ProductRequirementCard = (props) => {
  const [requirements, setRequirements] = useState([]);
  const [requirement, setRequirement] = useState();
  const [sequence, setSequence] = useState(10);
  const [dropDowns, setDropDowns] = useState({ policyRequirement: [] });
  const [showAdd, setShowAdd] = useState(false);
  const [removed, setRemoved] = useState(false);
  const { id } = useParams();
  const { api, abortSignal, auth } = useApi();
  const { reload, toggleReload } = useReload();
  const sequenceRef = useRef();

  const addRequirement = async () => {
    if (requirement) {
      try {
        const response = await api.add(`/products/${id}/requirements`, {
          policyRequirementId: requirement.value,
          scope: "claim",
          sequence: sequence,
        });
        if (response.ok) {
          setRequirement();
          toggleReload();
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const removeRequirement = async (rid) => {
    if (rid) {
      try {
        const response = await api.delete(
          `/products/${id}/requirements/${rid}`
        );

        if (response.ok) {
          setRemoved(!removed);
          toggleReload();
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const getDropDowns = async () => {
    try {
      const models = ["policyRequirement"];
      const { data } = await api.list(`/dropdowns`, models);
      setDropDowns(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const filterRequirements = dropDowns.policyRequirement.filter((element) => {
      return !requirements.find((element1) => element1.id == element.value);
    });

    setDropDowns({ ...dropDowns, policyRequirement: filterRequirements });
  }, [requirements]);

  useEffect(() => {
    if (requirement) {
      setShowAdd(true);
    } else {
      setShowAdd(false);
    }
  }, [requirement]);

  useEffect(() => {
    showAdd && sequenceRef.current.focus();
  }, [showAdd]);

  useEffect(() => {
    getDropDowns();
    const callApi = async () => {
      try {
        const { data } = await api.list(
          `/products/${id}/requirements?scope=claim`
        );
        setRequirements(data);
      } catch (error) {
        console.error(error);
      }
    };
    callApi();

    const abortApiCall = () => abortSignal && abortSignal.abort;
    return abortApiCall;
  }, [id, auth, requirement, removed, reload]);

  return (
    <>
      <p className="border-top pt-2 text-info">Add Requirement</p>
      <div className="d-flex">
        <div className="flex-grow-1">
          <Select
            options={
              dropDowns && dropDowns["policyRequirement"]
                ? dropDowns["policyRequirement"]
                : []
            }
            onChange={(selectedOption) => setRequirement(selectedOption)}
            value={requirement || ""}
          />
        </div>
      </div>
      {showAdd && (
        <div className="d-flex mt-3">
          <div className="flex-fill">
            <Form.Group className="mb-3">
              <Form.Label>Sequence</Form.Label>
              <Form.Control
                ref={sequenceRef}
                type="number"
                placeholder="sequence"
                min={0}
                defaultValue={10}
                onChange={(e) => setSequence(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="mt-4 flex-fill">
            <Button
              type="button"
              onClick={addRequirement}
              className="btn btn-icon btn-primary ms-2"
            >
              <i className="bi bi-plus fs-5"></i>
            </Button>
          </div>
        </div>
      )}
      <>
        <ListGroup as="ol" numbered className="mt-3">
          <ReactSortable
            list={requirements}
            setList={setRequirements}
            chosenClass="bg-gray"
          >
            {requirements &&
              requirements?.map((policyRequirement) => (
                <ListGroupItem
                  as="li"
                  className="d-flex justify-content-between align-items-start mb-2 border rounded shadow-sm"
                  key={policyRequirement.id}
                >
                  <div className="ms-2 me-auto">
                    <div className="fw-bold">
                      {policyRequirement.ProductRequirement.sequence}
                      {". "}
                      {policyRequirement?.name || ""}
                    </div>
                    <small className="text-primary">
                      {policyRequirement?.type || ""}
                    </small>
                  </div>
                  <Button
                    variant="danger"
                    onClick={() => removeRequirement(policyRequirement?.id)}
                    className="btn-icon"
                  >
                    <i className="bi bi-trash-fill fs-5"></i>
                  </Button>
                </ListGroupItem>
              ))}
          </ReactSortable>
        </ListGroup>
        {!requirements && "No Requirements"}
      </>
    </>
  );
};

export default ProductRequirementCard;
